import { Injectable } from '@angular/core';

const TOKEN_KEY = 'ss_offline_session';

export interface CachedSession {
  id: string;
  email: string;
  fullName: string;
  firstName: string;
  lastName: string;
  planCode: 'starter' | 'pro' | 'premium';
  mandantId: string;
  roles: string[];
  trialStartDate: string | null;
  lastOnlineLogin: string | null;
}

@Injectable({ providedIn: 'root' })
export class KeycloakOfflineService {
  private readonly OFFLINE_DAYS = 30;

  save(session: Omit<CachedSession, 'lastOnlineLogin'>): void {
    const data: CachedSession = {
      ...session,
      lastOnlineLogin: new Date().toISOString(),
    };
    localStorage.setItem(TOKEN_KEY, JSON.stringify(data));
  }

  getOfflineDays(): number {
    const cached = this.get();
    if (!cached?.lastOnlineLogin) return 0;
    const diff = Date.now() - new Date(cached.lastOnlineLogin).getTime();
    return Math.floor(diff / (1000 * 60 * 60 * 24));
  }


  isSessionStillValid(): boolean {
    const data = this.has() && this.getOfflineDays() <= this.OFFLINE_DAYS;
    console.log('[SmartSheep] Offline-Session abgelaufen - Login erforderlich', data);
    return data;
  }

  get(): CachedSession | null {
    try {
      const raw = localStorage.getItem(TOKEN_KEY);
      return raw ? (JSON.parse(raw) as CachedSession) : null;
    } catch {
      return null;
    }
  }

  has(): boolean {
    return !!this.get();
  }

  remove(): void {
    localStorage.removeItem(TOKEN_KEY);
  }

  clear(): void {
    localStorage.clear();
  }
}
